export var MALL_STATUS = {
  LIVE: 'LIVE',
  TEST: 'TEST',
  NEW: 'NEW',
  DEL: 'DEL',
  isActive: function isActive(status) {
    return status === MALL_STATUS.LIVE || status === MALL_STATUS.NEW;
  }
};